import styled from '@emotion/styled';
import { bodyM, subTitle2, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  width: 100%;
  background: #01372a;
`;

export const ImageWrapper = styled.div`
  position: relative;
  object-fit: cover;
  width: 282px;
  height: 59px;
  flex-shrink: 0;
`;

export const ImageDesktopWrapper = styled.div`
  position: relative;
  object-fit: cover;
  width: 381px;
  height: 68px;
  flex-shrink: 0;
`;

export const Text = styled.div`
  ${bodyM};
  color: ${vars.neutral[40]};
  text-align: center;
  white-space: pre-line;

  ${DESKTOP} {
    ${bodyM};
    color: ${vars.neutral[40]};
  }
`;

export const GrassHallWrapper = styled.div`
  width: 100%;
`;

export const GrassHallText = styled.span`
  ${subTitle2};
  color: ${vars.neutral[80]};
`;

export const GrassHallGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 16px;

  ${DESKTOP} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const GrassHallItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  background: ${vars.neutral[0]};
`;

export const GrassHallItemCountContainer = styled.div`
  height: 24px;
  padding: 4px 10px;
  border-radius: 4px;
  background: #f4f8f1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1px;
`;

export const TextCountNumber = styled.span`
  color: #07735c;
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextCountKorea = styled.span`
  color: #07735c;
  text-align: center;
  font-family: Pretendard;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextName = styled.span`
  text-align: center;
  font-family: Pretendard;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;

  color: ${vars.neutral[60]};
`;

export const RankCountTextNumber = styled.span`
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`;

export const RankCountTextKorea = styled.span`
  text-align: center;
  font-family: Pretendard;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
`;

export const RankTextName = styled.span`
  text-align: center;
  font-family: Pretendard;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;

  color: #81898f;
`;

export const ShareTitle = styled.span`
  white-space: pre-line;
  text-align: center;
  ${title2};
  color: #fff;
`;

export const ShareIconWrapper = styled.div`
  display: flex;
  padding: 9px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  border-radius: 121px;
  border: 1px solid #5cb588;
  background: #e5f2ea;
`;
